import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm, SubmitHandler } from 'react-hook-form';
import {
  FormErrorMessage,
  Container,
  FormControl,
  FormLabel,
  Input,
  Button,
  VStack,
  HStack,
  Alert,
  // アイコンリスト // Icon - Chakra UI https://chakra-ui.com/docs/components/icon
  AlertIcon,
  AlertTitle,
  Divider,
  Box, Text, Tooltip,
  Image,
  Flex, Link,IconButton,Stack,useDisclosure,
} from "@chakra-ui/react";
// import {useState} from "react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";

//import {client} from "@/client"
import {client, baseUrl} from "@/client"
import {setBearerToken} from "@/auth";

import {
  Page,
  PageHeader,
  PageBody,
} from "@/components/layout"

import './LoginForm.css';

const Header: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
//  const navigate = useNavigate();

  return (
    <Box bg="white" px={2} >

      {/* <Flex h={16} alignItems="center" justifyContent="space-between"> */}

      {/* ロゴ部分 */}
      <Image src="/ap/img/usaprologo2.png" objectFit="contain" p={3} height="6em" />

        {/* ナビゲーションリンク
        <HStack as="nav" spacing={4} display={{ base: "none", md: "flex" }}>
          <Button variant="link" color="white">
            Home
          </Button>
          <Button variant="link" color="white">
            About
          </Button>
          <Button variant="link" color="white">
            Contact
          </Button>
        </HStack>
        */}

        {/* ハンバーガーメニュー (モバイル対応)
        <IconButton
          size="md"
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          aria-label="Open Menu"
          display={{ md: "none" }}
          onClick={isOpen ? onClose : onOpen}
        />
        */}
      {/* </Flex> */}

      {/* モバイルメニュー
      {isOpen && (
        <Box pb={4} display={{ md: "none" }}>
          <Stack as="nav" spacing={4}>
            <Button variant="link" color="white">
              Home
            </Button>
            <Button variant="link" color="white">
              About
            </Button>
            <Button variant="link" color="white">
              Contact
            </Button>
          </Stack>
        </Box>
      )}
       */}
    </Box>
  );
};

const Footer: React.FC = () => {
  return (
    <Box bg="#002060" color="white" py={2}>
      {
        /* フッターの上部 */}
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="center"
        px={4}
      >

        <Box borderRadius={"4px"} border={"1px"} borderColor={"white"}>
          <Text m={"0.5em"}>事業再構築</Text>
        </Box>

        {/* 左側：ロゴや説明文
        <VStack align={{ base: "center", md: "flex-start" }} mb={{ base: 4, md: 0 }}>
          <Text fontWeight="bold" fontSize="lg">
            MyApp
          </Text>
          <Text fontSize="sm">A simple and modern web application footer.</Text>
        </VStack>
         */}

        {/* 中央：ナビゲーションリンク
        <HStack spacing={4} mb={{ base: 4, md: 0 }}>
          <Link href="#" fontSize="sm" _hover={{ textDecoration: "underline" }}>
            About
          </Link>
          <Link href="#" fontSize="sm" _hover={{ textDecoration: "underline" }}>
            Contact
          </Link>
          <Link href="#" fontSize="sm" _hover={{ textDecoration: "underline" }}>
            Privacy Policy
          </Link>
        </HStack>
         */}

        {/* 右側：SNSアイコン
        <HStack spacing={4}>
          <Link href="#" isExternal>
            <FaFacebook size="20px" />
          </Link>
          <Link href="#" isExternal>
            <FaTwitter size="20px" />
          </Link>
          <Link href="#" isExternal>
            <FaInstagram size="20px" />
          </Link>
        </HStack>
         */}

        {/* yuberロゴ部分 */}
        <Box>
          <Image src="/ap/img/yuberlogo.png" objectFit="contain" p={2} height="5em"/>
        </Box>

      </Flex>

      {/* 区切り線
      <Divider my={4} borderColor="gray.600" />
       */}

      {/* フッターの下部
      <Text textAlign="center" fontSize="sm">
        © {new Date().getFullYear()} MyApp. All rights reserved.
      </Text>
       */}
    </Box>
  );
};

type FormDataIDPASS = {
  memberId: string;
  password: string;
};

type FormDataCODE = {
  code: string;
};

export const Login = () => {
  const [formIDPASSError, setFormIDPASSError] = useState('');

  const {
    register: registerIDPASSElement,
    handleSubmit: handleSubmitFormIDPASS,
    formState: { errors: formIDPASSErrors },
  } = useForm<FormDataIDPASS>();

  const [formCODEError, setFormCODEError] = useState('');

  const {
    register: registerCODEElement,
    handleSubmit: handleSubmitFormCODE,
    formState: { errors: formCODEErrors },
  } = useForm<FormDataCODE>();


  const navigate = useNavigate();

  const submitIDPASSIfValid : SubmitHandler<FormDataIDPASS> = (async (data) => {

      const id = data.memberId.trim();
      const password =  data.password.trim();

      const resp = await client.login({
        id: id,
        password: password,
        code: "",
      })
      
      if (!resp.error) {
        console.log("Succeeded to login");
        setBearerToken(resp.bearerToken)
        if (resp.currentUser?.optRole === "student") {
          navigate("/works")
        } else {
          navigate('/manage');
        }
      } else {
        console.log("Failed to login");
        setFormIDPASSError(`ログインしっぱい。 ${resp.error.message}`);
      }
  });

  const submitCODEIfValid : SubmitHandler<FormDataCODE> = (async (data) => {

    const code = data.code.trim();

    const resp = await client.login({
      id: "",
      password: "",
      code: code,
    })
    
    if (!resp.error) {
      console.log("Succeeded to login");
      setBearerToken(resp.bearerToken)
      if (resp.currentUser?.optRole === "student") {
        navigate("/works")
      } else {
        navigate('/manage');
      }
    } else {
      console.log("Failed to login");
      setFormCODEError(`ログインしっぱい。 ${resp.error.message}`);
    }
  });

  const bgimg = "/ap/img/loginbg" + String(new Date().getMonth() + 1).padStart(2, '0') + ".png"

  return <Page>
    <Box>

      {/* ヘッダー */}
      <Header />
    
      {/* 中身 */}
      <Box display="flex" justifyContent="center" alignItems="center" p={20}
        backgroundSize="cover"
        backgroundRepeat="no-repeat"
        backgroundPosition="center"      
        backgroundImage={`url('${bgimg}')`}
      >

        <VStack className="login_form" spacing={10} align="center">

          <Box as="form" onSubmit={handleSubmitFormIDPASS(submitIDPASSIfValid)}>

            <VStack className="section_block">

              <FormControl>
                <div className="section_titie">かいいんばんごうとパスワードがあるひとはこちら</div>
              </FormControl>

              <HStack spacing={6}>
                <FormControl isInvalid={Boolean(formIDPASSErrors.memberId)} >
                  <FormLabel><span>かいいんばんごう</span></FormLabel>
                  <Input className="login_form_short"
                    {...registerIDPASSElement("memberId", {
                          required: "かいいんばんごうをいれてね。",
                        })
                    }
                  />
                  <FormErrorMessage>
                    { formIDPASSErrors.memberId && formIDPASSErrors.memberId.message }
                  </FormErrorMessage>
                </FormControl>

                <FormControl isInvalid={Boolean(formIDPASSErrors.password)}>
                  <FormLabel htmlFor="passwordElem"><span>パスワード</span></FormLabel>
                  <Input className="login_form_middle"
                    type="password"
                    placeholder="password"
                    {...registerIDPASSElement("password", {
                          required: "パスワードをいれてね。",
                        })
                    }
                  />
                  <FormErrorMessage>
                    { formIDPASSErrors.password && formIDPASSErrors.password.message }
                  </FormErrorMessage>
                </FormControl>
              </HStack>

              <Button className="login_form_button" type="submit">はじめる</Button>

              {
               formIDPASSError && <Alert status="error">
                    <AlertIcon />
                    <AlertTitle>{formIDPASSError}</AlertTitle>
                    {/*<AlertDescription>{formIDPASSError}</AlertDescription>*/}
                  </Alert>
              }
  
            </VStack>
          </Box>



          <Box as="form" onSubmit={handleSubmitFormCODE(submitCODEIfValid)}>

            <VStack className="section_block2">


              <FormControl>
                <div className="section_titie">ログインばんごうがあるひとはこちら</div>
              </FormControl>

              <HStack spacing={6}>

                <FormControl isInvalid={Boolean(formCODEErrors.code)} alignItems={"center"} >
                  <FormLabel htmlFor="codeElem"><span>ログインばんごう</span></FormLabel>
                  <Input className="login_form_short"
                  {...registerCODEElement("code", {
                        required: "ログインばんごうをいれてね。",
                      })
                  }
                  />
                <FormErrorMessage>
                  { formCODEErrors.code && formCODEErrors.code.message }
                </FormErrorMessage>
                </FormControl>

              </HStack>

              <Button className="login_form_button"  type="submit">はじめる</Button>


              {
                formCODEError && <Alert status="error">
                    <AlertIcon />
                    <AlertTitle>{formCODEError}</AlertTitle>
                    {/*<AlertDescription>{formCODEError}</AlertDescription>*/}
                  </Alert>
              }
            </VStack>
          </Box>

        </VStack>
      
    

    
      </Box>

      {/* フッター */}
      <Footer />

    </Box>
  </Page>
}
